import React, { useContext } from 'react';
import { NavBar, NavLink } from '@magoosh/b2b/app/organisms/nav_bar';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { Subjects } from '@magoosh/b2b/app/pages/reporting/subjects';
import { PracticeTests } from '@magoosh/b2b/app/pages/reporting/practice_tests';
import { AppContext } from '@magoosh/b2b/app/app_context';
import { Modules } from '@magoosh/b2b/app/pages/reporting/modules';

export const Reporting: React.FC = () => {
  const appContext = useContext(AppContext);
  const { url, path } = useRouteMatch();

  return <>
    <NavBar>
      <NavLink to={`${url}/subjects`} text="Subjects" />
      <NavLink to={`${url}/practice-tests`} text="Practice Tests" />
      {appContext.showModulesReport &&
        <NavLink to={`${url}/modules`} text="Modules" />
      }
    </NavBar>
    <Switch>
      <Route path={`${path}/subjects`}>
        <Subjects />
      </Route>
      <Route path={`${path}/practice-tests`}>
        <PracticeTests />
      </Route>
      <Route path={`${path}/modules`}>
        <Modules />
      </Route>
      <Route exact path={path}>
        <Redirect to={`${url}/subjects`} />
      </Route>
    </Switch>
  </>;

}
